import React, { Component } from 'react'
import {Helmet} from 'react-helmet'

import NavBar from '../../components/NavBar';
import PastCompetitionData from '../../components/PastCompetitionData';

import { Container, Row, Col, Image, Badge } from 'react-bootstrap';

export default class PastCompetition2019 extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>ISSC | The 2019 Competition</title>
                </Helmet>
                <NavBar hasHero={false} />
                <br />
                <Container>
                    <Row>
                        <Col>
                            <h1>The 2019 Competition<Badge variant="secondary">Upcoming...</Badge></h1>
                        </Col>
                    </Row>
                    <PastCompetitionData teams="8" physicsTopic="Glider" chemistryTopic="Water Purification" winner="To Be Determined..." />
                    <Row>
                        <Col lg="4 auto">
                            <Image className="contact-image-1" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Ftruc.JPG?alt=media&token=cca64fa5-e154-4bc7-b199-c4c3ede13ac2" />
                            <Image className="contact-image-2" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fjoon_young.JPG?alt=media&token=72ef2bee-314e-4010-8440-697c5bbbacc9" />
                            <br />
                            <br />
                            <Image alt="Students Conducting Experiment" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fexperiment.JPG?alt=media&token=19f9c24f-d96c-4850-9158-3f44cfeb152d" rounded fluid />
                        </Col>
                        <Col>
                            <Image alt="Students Working" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fworking.JPG?alt=media&token=774fd37e-78cc-47d3-bb5d-b717937fc05a" rounded fluid />
                            <p>
                                In 2019, there were 8 teams from five schools in Ho Chi Minh City:  Saigon South 
                                International School, International School of Ho Chi Minh City, British International 
                                School, Renaissance International School Saigon, and Anglophone British Curriculum 
                                International School. Each team had a maximum of 8 members and one leader. 
                            </p>
                            <p>
                                This year, there were changes to the preparation of the competition. In addition to 
                                the Director, we added two positions to help improve planning and sponsorship 
                                opportunities. These positions include an editor who makes the website and an 
                                organizer who aids with certain tasks like taking photos and prepare documents. 
                            </p>
                            <p>
                                The physics topic was to make a glider that can fly the furthest distance using a 
                                handmade launchpad. The chemistry topic was to purify five liters of river water in 
                                20 minutes. 
                            </p>
                            <br />
                            <br />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}
